const defatultStoreName = 'product';

export function createTypes(storeName = defatultStoreName) {
    return {
        SET_PRODUCT: `${storeName}.SET_PRODUCT`,
        LOAD_PRODUCT: `${storeName}.LOAD_PRODUCT`,
        SET_LOADING: `${storeName}.SET_LOADING`,
        SHOW_PRODUCT_DETAILS: `${storeName}.SHOW_PRODUCT_DETAILS`,
        SHOW_PRODUCT_VIDEO: `${storeName}.SHOW_PRODUCT_VIDEO`,
        CLEAR_PRODUCT_VIDEO: `${storeName}CLEAR_PRODUCT_VIDEO`,
        SET_FOCUSED: `${storeName}.SET_FOCUSED`,
        LOAD_PRODUCT_VARIANT_DATA: `${storeName}.LOAD_PRODUCT_VARIANT_DATA`,
        PRODUCT_IMPRESSION_VIEW: `${storeName}.PRODUCT_IMPRESSION_VIEW`,
        UPDATE_PRODUCT_WITH_VARIANT_DATA: `${storeName}.UPDATE_PRODUCT_WITH_VARIANT_DATA`,
        UPDATE_PRODUCT_WITH_VARIANT_PRICE_DATA: `${storeName}.UPDATE_PRODUCT_WITH_VARIANT_PRICE_DATA`,
        RESET: `${storeName}.RESET`,
        SET_QUANTITY: `${storeName}.SET_QUANTITY`,
        SET_PRODUCT_CODE_TO_BE_REMOVED: `${storeName}.SET_PRODUCT_CODE_TO_BE_REMOVED`,
        SET_PRODUCT_DATA_FOR_ADD_PRODUCT_REVIEW: `${storeName}.SET_PRODUCT_DATA_FOR_ADD_PRODUCT_REVIEW`,
        OPEN_PDP_RTS: `${storeName}.OPEN_PDP_RTS`,
        SET_INITIAL_QUANTITY: `${storeName}.SET_INITIAL_QUANTITY`,
        REMOVE_INITIAL_QUANTITY: `${storeName}.REMOVE_INITIAL_QUANTITY`,
        COLOR_VARIANTS_POPUP_SELECT: `${storeName}.COLOR_VARIANTS_POPUP_SELECT`,
        COLOR_VARIANTS_POPUP_UPDATE: `${storeName}.COLOR_VARIANTS_POPUP_UPDATE`,
        COLOR_VARIANTS_POPUP_SYNC: `${storeName}.COLOR_VARIANTS_POPUP_SYNC`,
        COLOR_VARIANTS_POPUP_SUBMIT: `${storeName}.COLOR_VARIANTS_POPUP_SUBMIT`,
        SHOW_INFORM_ME_ONLY: `${storeName}.SHOW_INFORM_ME_ONLY`,
        CUSTOM_CSS_LOADED: `${storeName}.CUSTOM_CSS_LOADED`,
        LOAD_PRODUCT_HOME_DELIVERY_DATE: `${storeName}.LOAD_PRODUCT_HOME_DELIVERY_DATE`,
        LOAD_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE: `${storeName}.LOAD_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE`,
        SET_PRODUCT_HOME_DELIVERY_DATE: `${storeName}.SET_PRODUCT_HOME_DELIVERY_DATE`,
        SET_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE: `${storeName}.SET_PRODUCT_PICKUP_IN_STORE_DELIVERY_DATE`,
        PRODUCT_VIEWED: `${storeName}.PRODUCT_VIEWED`,
        SET_BUNDLE_PRODUCT: `${storeName}.SET_BUNDLE_PRODUCT`,
        SET_THRESHOLD_PROMOTION_OBJECT: `${storeName}.SET_THRESHOLD_PROMOTION_OBJECT`,
    };
}

export default createTypes();
